import ApiService from "../ApiService";

const appointmentService = {
    saveAppointment (data) {
        return ApiService.post(`/appointment/`, data);
    },

    editAppointment (data) {
        return ApiService.post(`/appointment/edit`, data);
    },

    searchAppointments (data) {
        return ApiService.post('/appointment/search', data)
    },

    report (data) {
        return ApiService.post('/appointment/report', data)
    },

    getCancelReasons () {
        return ApiService.get('/appointment-cancel-reason/')
    },

    cancelAppointment(data) {
        return ApiService.post(
            '/appointment/cancel',
            data
        );
    },

    attend (data) {
        return ApiService.post(
            `/appointment/attend`,
            data
        );
    },

    attendMultiple (data) {
        return ApiService.post(
            `/appointment/attend-multiple`,
            data
        );
    },

    cancelMultiple (data) {
        return ApiService.post(
            `/appointment/cancel-multiple`,
            data
        );
    },

    confirm (data) {
        return ApiService.post(
            `/appointment/confirm`,
            data
        );
    }
};
export default appointmentService;